module.exports = __webpack_public_path__ + "img/start_magazine.3f8b7cc0.png";